import styled from 'styled-components';

const SBody = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 85px;

  &.has-min-width {
    margin-bottom: 95px;
    margin-right: 20px;
    min-width: 1280px;
  }
`;

export default SBody;
